export enum EShowMore {
    FULL_TEXT = 'fullText',
    DIALOG = 'dialog',
    EXTERNAL = 'external'
}
